<div class="center-container" fxLayoutAlign="center center">
  <ng-container *ngIf="otpService.initialLoading">
    <div id="default-load" class="loading-icon-bubbles">Loading...</div>
  </ng-container>
  <ng-container *ngIf="!otpService.initialLoading">
    <mat-card class="small-card">
      <mat-card-content>
        <otp-error *ngIf="otpService.error?.fatalError"></otp-error>
        <ng-container *ngIf="!otpService.error?.fatalError">
          <otp-send *ngIf="otpService.currentScreen == OtpScreen.SEND"></otp-send>
          <otp-resend *ngIf="otpService.currentScreen == OtpScreen.RESEND"></otp-resend>
          <otp-verify *ngIf="otpService.currentScreen == OtpScreen.VERIFY"></otp-verify>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
